/**
 * 旬・月の目盛と縦線（#291 §2.1.1、docs/102。案件の{schedule}＝Gantt.tsx と全体の{schedule}＝Overview.tsx が同じものを使う。紙は packages/paper）
 *   旬の見出し：上旬・中旬・下旬（1〜10日・11〜20日・21〜末日。狭ければ「上・中・下」）。旬・月の見出しに日付は出さない
 *   縦線：日＝日ごとの境に薄い点線／旬・月＝旬の境（11日・21日）に点線・月の境に実線。バーの下（地の層）に描く
 *   位置は時間軸の物差し（timeline.ts の scaleOf＝旬は1日の幅が旬の日数で変わる）
 */
import { SCHEDULE_JUN_LABEL, SCHEDULE_JUN_SHORT } from "@genbaryoku/contract";
import { textWidth, type TimeScale, type View } from "./timeline.js";

/** 旬の目（表の何日目から・何日ぶん・上旬 0／中旬 1／下旬 2）。表の最初の日が旬の途中なら、その日から */
export function junTicks(days: readonly string[]): { i: number; n: number; k: 0 | 1 | 2 }[] {
  const out: { i: number; n: number; k: 0 | 1 | 2 }[] = [];
  days.forEach((d, i) => {
    const dd = Number(d.slice(8, 10));
    if (i !== 0 && dd !== 1 && dd !== 11 && dd !== 21) return;
    const last = out[out.length - 1];
    if (last) last.n = i - last.i;
    out.push({ i, n: days.length - i, k: dd <= 10 ? 0 : dd <= 20 ? 1 : 2 });
  });
  return out;
}

/** 縦線の種類と位置（表の何日目の左端か） */
export function scaleLines(view: View, days: readonly string[]): { i: number; kind: "month" | "dot" }[] {
  const out: { i: number; kind: "month" | "dot" }[] = [];
  for (let i = 1; i < days.length; i++) {
    const d = days[i]!;
    if (view === "day") out.push({ i, kind: "dot" });
    else if (d.endsWith("-01")) out.push({ i, kind: "month" });
    else if (d.endsWith("-11") || d.endsWith("-21")) out.push({ i, kind: "dot" });
  }
  return out;
}

/** 地の層に描く縦線（バーの下） */
export function ScaleLines({ view, days, sc }: { view: View; days: readonly string[]; sc: TimeScale }) {
  return (
    <>
      {scaleLines(view, days).map((l) => (
        <span key={l.i} className={"sch-vl " + l.kind} style={{ left: sc.x(l.i) }} data-testid={l.kind === "month" ? "sch-vl-month" : "sch-vl-dot"} />
      ))}
    </>
  );
}

/** 旬の目盛の下の段（「上旬・中旬・下旬」。入らなければ「上・中・下」、それも入らなければ出さない）。月の目盛は1段なので呼ばない */
export function JunTicks({ days, sc }: { days: readonly string[]; sc: TimeScale }) {
  return (
    <>
      {junTicks(days).map((u) => {
        const w = sc.x(u.i + u.n) - sc.x(u.i);
        const long = SCHEDULE_JUN_LABEL[u.k];
        const label = textWidth(long, 14) + 8 <= w ? long : textWidth(SCHEDULE_JUN_SHORT[u.k], 14) + 4 <= w ? SCHEDULE_JUN_SHORT[u.k] : "";
        return (
          <span key={u.i} className={"jn" + (u.k === 0 && u.i > 0 ? " m" : "")} style={{ left: sc.x(u.i), width: w }} data-testid="sch-jun" title={long}>
            {label}
          </span>
        );
      })}
    </>
  );
}
